import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UtilsService } from '../utils.service';
import { CsvBuilder } from './csvbuilder';

@Injectable({
  providedIn: 'root'
})
export class CsvexportService {

  constructor(private sanitizer: DomSanitizer, private utils: UtilsService) { }

  public prepareCSV( toExport: any ): SafeResourceUrl {
    const content = this.getCSV( toExport );
    const blob = new Blob([content], { type: 'text/csv;charset=UTF-8' });
    return this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
  }

  /**
   * Builds CSV content from an array of JSON Objects.
   * @param toExport : the array of objects 
   * @returns a string being a csv content
   */
  private getCSV( toExport: any ): string {
    const csvBuilder = new CsvBuilder();

    // header : 
    for ( let i = 0; i < Object.keys( toExport[0] ).length; i ++ ) {
      csvBuilder.addValue( Object.keys( toExport[0] )[i] );      
    }

    csvBuilder.newLine();

    // Data
    toExport.forEach( (element: any) => {
      let val : string;
      for (const [key, value] of Object.entries(element)) {
        /** We want to convert the ugly timestamp to a beautiful DD/MM/YYYY date */
        if( key == 'DEBUT'){
          val = this.utils.getNiceDateHeure ( `${value}` );
        } else if (key == 'DATE_DE_MISE_EN_SERVICE') {
          val = this.utils.getNiceDate ( `${value}` );
        } else {
          val = `${value}`; 
        }
        csvBuilder.addValue( val );
      }

      csvBuilder.newLine();
     
    });
    return csvBuilder.data;
  }

}
